import { CellColors } from '../model/colors.model';

enum RoadRiskRatings {
  veryHigh = 'very high',
  high = 'high',
  medium = 'medium',
  low = 'low',
  notStarted = 'not started',
  notAssigned = 'not assigned',
}

export const roadRiskRatingCssClass = (rating: RoadRiskRatings | null, dueDate: string | null): CellColors | null => {
  let notStartedClass: CellColors;
  rating = rating.toLowerCase() as RoadRiskRatings;

  if (dueDate) {
    notStartedClass = new Date(dueDate) <= new Date() ? CellColors.red : CellColors.amber;
  } else {
    notStartedClass = CellColors.red;
  }

  switch (rating) {
    case RoadRiskRatings.veryHigh:
      return CellColors.black;
    case RoadRiskRatings.high:
      return CellColors.red;
    case RoadRiskRatings.medium:
      return CellColors.amber;
    case RoadRiskRatings.low:
      return CellColors.green;
    case RoadRiskRatings.notStarted:
      return notStartedClass;
    case RoadRiskRatings.notAssigned:
      return CellColors.grey;
    default:
      return null;
  }
};
